import { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import { useAppDispatch } from "../../../../reduxToolkit/hooks";
import { fetchChatApiData, fetchChatMemberApiData } from "../../../../reduxToolkit/reducers/chatSlice";
import { Chats, GroupChat } from "../../../../constants";
import Sidebar from "../common/sideBar";
import ChatBody from "../common/chatWindow/ChatBody";
import { ContactEdit } from "../common/ContactEdit";
import { GroupChatHeader } from "../../../../data/applications/Chat";
import { dynamicImage } from "../../../../utils";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import { Image } from "../../../../coreComponents/Image";

// This component displays a group chat interface with the specified group.
const GroupChatContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchChatMemberApiData());
    dispatch(fetchChatApiData());
  }, [dispatch]);

  return (
    <>
      <Breadcrumbs mainTitle={GroupChat} parent={Chats} />
      <Container fluid>
        <Row className="g-0">
          <Sidebar />
          <Col xxl="9" xl="8" md="7" className="box-col-7">
            <Card className="right-sidebar-chat">
              <div className="right-sidebar-title">
                <div className="common-space">
                  <div className="chat-time group-chat">
                    <ul>
                      {/* Mapping through GroupChatHeader to render group chat members' profile images */}
                      {GroupChatHeader.map((data, index) => (
                        <li key={index}>
                          <Image className="img-fluid rounded-circle" src={dynamicImage(`${data}`)} alt="user" />
                        </li>
                      ))}
                      <li>
                        <div className="custom-name profile-count light-background">
                          <p className="f-w-500">9+</p>
                        </div>
                      </li>
                    </ul>
                    <div>
                      <span>Meeting Department</span>
                      <p>35 Members</p>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="contact-edit chat-alert bg-light-danger">
                      <i className="icon-info-alt txt-danger" />
                    </div>
                    <ContactEdit dropClass="chat-alert" />
                  </div>
                </div>
              </div>
              <ChatBody />
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default GroupChatContainer;
